import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import BenchmarkingModalShell from '../Modals/BenchmarkingModalShell'

@observer
class BenchmarkingModal extends Component {
    changeYears = ({ value }) => {
        const { DataExplorerStore } = this.props
        const { changeYears } = DataExplorerStore

        changeYears(value.map((v) => Number(v)))
    }

    changePeriods = ({ value }) => {
        const { DataExplorerStore } = this.props
        const { changeIncludedPeriods } = DataExplorerStore

        changeIncludedPeriods(value.map((v) => Number(v)))
    }

    changeBenchmarks = ({ value }) => {
        const { DataExplorerStore } = this.props
        const { changeBenchmarks } = DataExplorerStore

        changeBenchmarks(value)
    }

    getIndustryName = (DataExplorerStore) => {
        const industries = R.pathOr(undefined, ['appStore', 'client', 'industries'], DataExplorerStore)
        const industryCode = DataExplorerStore.industry
        const industry = industries.find((i) => i.code === industryCode)
        return industry?.name
    }

    render() {
        const { DataExplorerStore } = this.props
        const {
            yearOptions, years, benchmarks, benchmarkOptions,
            periodOptions, periods, showBenchmarkingModal, toggleBenchmarkingModal,
        } = DataExplorerStore

        const industry = this.getIndustryName(DataExplorerStore)

        return (
            <BenchmarkingModalShell
                storeType="dataExplorer"
                industry={industry}
                show={showBenchmarkingModal}
                onClose={toggleBenchmarkingModal}
                benchmarkOptions={benchmarkOptions}
                selectedBenchmarks={benchmarks}
                changeBenchmarks={this.changeBenchmarks}
                yearOptions={yearOptions}
                selectedYears={years}
                changeYears={this.changeYears}
                periodOptions={periodOptions}
                selectedPeriods={periods}
                changePeriods={this.changePeriods}
            />
        )
    }
}

export default BenchmarkingModal
